import { Link } from "gatsby"
import React from "react"
import { SocialIcon } from "react-social-icons"

function FooterMainNav() {
  const links = [
    {
      name: "FAQs",
      link: "/gift-cards/faq/",
    },
    {
      name: "Contact Us",
      link: "/contact-us/",
    },
    {
      name: "Terms & Conditions",
      link: "/terms-and-conditions/",
    },
    {
      name: "Privacy",
      link: "https://www.mbplc.com/privacy/",
    },
    {
      name: "Cookie Policy",
      link: "https://www.mbplc.com/cookies/",
    },
    {
      name: "Accessibility",
      link: "/accessibility/",
    },
  ]

  return (
    <div className="mx-auto max-w-[1110px] px-4">
      <nav className="flex flex-wrap items-center justify-between py-6 mb-6">
        <div
          className={`block w-full block flex-grow flex items-center w-auto gap-10 flex-wrap`}
        >
          <div className="text-sm flex-grow flex justify-between flex-wrap">
            {links.map(link => {
              // Check if this is an internal link
              if (link.link.startsWith("/")) {
                return (
                  <Link
                    to={link.link}
                    key={link.name}
                    className="block mt-4 mr-4 text-white lg:inline-block lg:mt-0 hover:text-gold uppercase"
                    activeClassName="!text-gold"
                  >
                    {link.name}
                  </Link>
                )
              } else {
                return (
                  <a
                    href={link.link}
                    key={link.name}
                    target="_blank"
                    rel="noreferrer"
                    className="block mt-4 mr-4 text-white lg:inline-block lg:mt-0 hover:text-gold uppercase"
                  >
                    {link.name}
                  </a>
                )
              }
            })}
          </div>
          <div className={`mx-auto`}>
            <SocialIcon
              url="https://x.com/intent/follow?source=followbutton&variant=1.0&screen_name=MBDiningOut"
              network="x"
              fgColor="currentColor"
              bgColor="rgba(255,255,255,0.25)"
              className="text-white hover:text-gold mr-4"
              target="_blank"
            />
            <SocialIcon
              url="http://www.facebook.com/profile.php?id=284214671700555"
              network="facebook"
              fgColor="currentColor"
              bgColor="rgba(255,255,255,0.25)"
              className="text-white hover:text-gold mx-4"
              target="_blank"
            />
            <SocialIcon
              url="https://www.instagram.com/diningoutgiftcard/"
              network="instagram"
              fgColor="currentColor"
              bgColor="rgba(255,255,255,0.25)"
              className="text-white hover:text-gold mx-4"
              target="_blank"
            />
            <SocialIcon
              url="https://www.linkedin.com/company/28795681/"
              network="linkedin"
              fgColor="currentColor"
              bgColor="rgba(255,255,255,0.25)"
              className="text-white hover:text-gold ml-4"
              target="_blank"
            />
          </div>
        </div>
      </nav>
    </div>
  )
}

export default FooterMainNav
